import {
  Alert,
  AppState,
  Image,
  ImageBackground,
  Platform,
  Share,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { AppIcons } from "../../../assets/images";
import { AppTheme } from "../../../utils/theme";
import { useNavigation, useRoute } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import LinearGradient from "react-native-linear-gradient";
import Spacer from "../../../components/global/Spacer";
import SoundPlayer from "react-native-sound-player";
import { userAction } from "../../../redux/reducers/user";
import { ROUTE_NAME } from "../../../utils/routes";
import socketService from "../../../services/randomplaySocketService";
import { useAppSelector } from "../../../redux/storeHook";
import { bannerAdKey, DEEP_LINK, truncateText } from "../../../utils/contants";
import FastImage from "react-native-fast-image";
import {
  BannerAd,
  BannerAdSize,
  useForeground,
} from "react-native-google-mobile-ads";
export interface Player {
  id: string;
  userId: string | null;
  name: string;
  profilePhoto: string | null;
  color: string;
  isReady: boolean;
  isHost: boolean;
  isBot?: boolean;
  disconnectedAt?: number | null;
}
export interface Room {
  id: string;
  hostId: string;
  maxPlayers: number;
  players: Player[];
  gameState: any | null;
  gameStarted: boolean;
  messages: any[];
}
export interface RootObject {
  roomId: string;
  playerName: string;
  color: string;
  isHost: boolean;
  userId: string;
  room: Room;
}
const RandomWaitingRoom = () => {
  const route = useRoute();
  const { userData } = useAppSelector((s) => s.user);
  const navigation = useNavigation<NativeStackNavigationProp<any>>();
  const {
    roomId,
    playerName,
    color,
    isHost: initialIsHost,
    userId,
    room: initialRoom,
  } = route.params as RootObject;
  const [room, setRoom] = useState<Room>(initialRoom);
  const localPlayer = useMemo(
    () => room.players.find((p) => p.userId === userId),
    [room, userId],
  );
  const isLocalHost = !!localPlayer?.isHost;
  const activePlayers = useMemo(
    () => room.players.filter((p) => !p.disconnectedAt),
    [room],
  );
  console.log("@ params : ", route.params);

  const bannerRef = useRef<BannerAd>(null);

  useForeground(() => {
    if (Platform.OS === "ios") {
      bannerRef.current?.load();
    }
  });

  useEffect(() => {
    setupSocketListeners();
    // AppState listener for foreground rejoin
    const subscription = AppState.addEventListener("change", (nextAppState) => {
      // @ts-ignore
      if (nextAppState === "active" && socketService.currentRoomId) {
        // Force rejoin on foreground to sync room state
        // For random, re-emit joinRandom, but simplified
      }
    });
    return () => {
      subscription?.remove();
    };
  }, []);
  const setupSocketListeners = () => {
    // @ts-ignore
    socketService.onPlayerJoined(({ player, room: updatedRoom }) => {
      console.log(
        "Player joined/rejoined, updating room:",
        updatedRoom.players.map((p: any) => ({
          name: p.name,
          active: !p.disconnectedAt,
          isBot: p.isBot,
        })),
      );
      setRoom(updatedRoom);
    });
    // @ts-ignore
    socketService.onPlayerLeft(({ room: updatedRoom }) => {
      setRoom(updatedRoom);
    });
    // @ts-ignore
    socketService.onRoomUpdated(({ room: updatedRoom }) => {
      setRoom(updatedRoom);
    });
    // @ts-ignore
    socketService.onGameStarted(({ players, numPlayers }) => {
      socketService.removeListener("playerJoined");
      socketService.removeListener("playerLeft");
      socketService.removeListener("roomUpdated");
      socketService.removeListener("gameStarted");
      navigation.replace(ROUTE_NAME.RandomOnlinePlay, {
        roomId,
        playerName,
        myColor: color,
        players,
        numPlayers,
      });
    });
  };
  const handleLeaveRoom = () => {
    Alert.alert("Leave Room", "Are you sure you want to leave?", [
      { text: "Cancel", style: "cancel" },
      {
        text: "Leave",
        style: "destructive",
        onPress: () => {
          socketService.leaveRoom(roomId);
          socketService.removeListener("playerJoined");
          socketService.removeListener("playerLeft");
          socketService.removeListener("roomUpdated");
          socketService.removeListener("gameStarted");
          navigation.goBack();
        },
      },
    ]);
  };
  return (
    <ImageBackground source={AppIcons.screenBackground} style={styles.mainView}>
      <TouchableOpacity
        onPress={() => {
          handleLeaveRoom();
          userAction.setTouchSound(true);
        }}
        style={styles.backIcon}
      >
        <Image
          source={AppIcons.BackIcon}
          style={{
            width: 50,
            height: 40,
          }}
          resizeMode="contain"
        />
      </TouchableOpacity>
      <View style={styles.container}>
        <Text style={styles.title}>Matching Players</Text>
        <Text style={styles.t2}>Waiting for players to join</Text>
        <Spacer size={30} />
        {/* 2 players ui */}
        {room?.maxPlayers == 2 && (
          <View style={styles.userView}>
            <View style={styles.userCard}>
              {activePlayers[0]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[0]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <View style={styles.rowView}>
                <Text style={styles.name}>
                  {activePlayers.length > 0 &&
                  activePlayers[0]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[0]?.name, 8)}
                </Text>
                {/* {activePlayers.length > 0 && activePlayers[0]?.isHost && !activePlayers[0]?.isBot && (
                  <LinearGradient
                    colors={[
                      AppTheme.colors.linearGradient_1,
                      AppTheme.colors.linearGradient_2,
                    ]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                    style={styles.hostView}
                  >
                    <Text style={styles.hostText}>HOST</Text>
                  </LinearGradient>
                )} */}
              </View>
            </View>
            <Image
              style={[
                styles.vsImg,
                {
                  left: "45%",
                },
              ]}
              source={AppIcons.vsIcon}
            />
            <View style={styles.userCard}>
              {activePlayers[1]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[1]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 2
                  ? activePlayers[1]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[1]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
          </View>
        )}
        {/* 3 player */}
        {room?.maxPlayers == 3 && (
          <View style={styles.userView}>
            <View style={styles.userCard}>
              {activePlayers[0]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[0]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <View style={styles.rowView}>
                <Text style={styles.name}>
                  {activePlayers.length > 0 &&
                  activePlayers[0]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[0]?.name, 8)}
                </Text>
                {/* {activePlayers.length > 0 && activePlayers[0]?.isHost && !activePlayers[0]?.isBot && (
                  <LinearGradient
                    colors={[
                      AppTheme.colors.linearGradient_1,
                      AppTheme.colors.linearGradient_2,
                    ]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                    style={styles.hostView}
                  >
                    <Text style={styles.hostText}>HOST</Text>
                  </LinearGradient>
                )} */}
              </View>
            </View>
            <Image
              style={[
                styles.vsImg,
                {
                  left: "45%",
                },
              ]}
              source={AppIcons.vsIcon}
            />
            <View style={styles.userCard}>
              {activePlayers[1]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[1]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 2
                  ? activePlayers[1]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[1]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
            <View style={styles.userCard}>
              {activePlayers[2]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[2]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 3
                  ? activePlayers[2]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[2]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
          </View>
        )}
        {/* 4 players */}
        {room?.maxPlayers == 4 && (
          <View style={styles.userView}>
            <View style={styles.userCard}>
              {activePlayers[0]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[0]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <View style={styles.rowView}>
                <Text style={styles.name}>
                  {activePlayers.length > 0 &&
                  activePlayers[0]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[0]?.name, 8)}
                </Text>
                {/* {activePlayers.length > 0 && activePlayers[0]?.isHost && !activePlayers[0]?.isBot && (
                  <LinearGradient
                    colors={[
                      AppTheme.colors.linearGradient_1,
                      AppTheme.colors.linearGradient_2,
                    ]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                    style={styles.hostView}
                  >
                    <Text style={styles.hostText}>HOST</Text>
                  </LinearGradient>
                )} */}
              </View>
            </View>
            <Image
              style={[
                styles.vsImg,
                {
                  left: "45%",
                },
              ]}
              source={AppIcons.vsIcon}
            />
            <View style={styles.userCard}>
              {activePlayers[1]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[1]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 2
                  ? activePlayers[1]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[1]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
            <View style={styles.userCard}>
              {activePlayers[2]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[2]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 3
                  ? activePlayers[2]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[2]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
            <View style={styles.userCard}>
              {activePlayers[3]?.profilePhoto ? (
                <FastImage
                  source={{ uri: activePlayers[3]?.profilePhoto }}
                  style={styles.icon}
                />
              ) : (
                <Image source={AppIcons.OnlineUser} style={styles.icon} />
              )}
              <Text style={styles.name}>
                {activePlayers.length >= 4
                  ? activePlayers[3]?.name == userData?.name
                    ? "You"
                    : truncateText(activePlayers[3]?.name, 8)
                  : "Waiting..."}
              </Text>
            </View>
          </View>
        )}
        <Spacer size={20} />
        <Text style={styles.bottomText}>
          {activePlayers.length >= room.maxPlayers
            ? "Starting game soon..."
            : "Matching in progress..."}
        </Text>
      </View>
      <View style={styles.botttomView}>
        <BannerAd
          ref={bannerRef}
          unitId={bannerAdKey}
          size={BannerAdSize.ANCHORED_ADAPTIVE_BANNER}
        />
      </View>
    </ImageBackground>
  );
};
export default RandomWaitingRoom;
const styles = StyleSheet.create({
  mainView: {
    flex: 1,
  },
  backIcon: {
    position: "absolute",
    top: 70,
    right: 0,
    zIndex: 999,
    elevation: 999,
  },
  container: {
    flex: 1,
    justifyContent: "center",
  },
  title: {
    alignSelf: "center",
    fontSize: 36,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  t2: {
    width: 280,
    alignSelf: "center",
    marginVertical: 10,
    fontSize: 16,
    color: `${AppTheme.colors.white}80`,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
    textAlign: "center",
  },
  userView: {
    width: "100%",
    paddingHorizontal: 24,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    position: "relative",
  },
  userCard: {
    alignItems: "center",
    marginTop: 10,
  },
  icon: {
    width: 130,
    height: 130,
    marginBottom: 7,
    borderRadius: 20,
  },
  vsImg: {
    position: "absolute",
    zIndex: 999,
    height: 80,
    width: 80,
  },
  rowView: {
    flexDirection: "row",
    alignItems: "center",
  },
  name: {
    fontSize: 16,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
    color: AppTheme.colors.white,
  },
  hostView: {
    width: 60,
    height: 25,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    marginLeft: 5,
  },
  hostText: {
    fontSize: 14,
    fontFamily: AppTheme.fonts.ALEXANDRIA_SEMIBOLD,
    color: AppTheme.colors.white,
  },
  bottomText: {
    alignSelf: "center",
    fontSize: 22,
    fontFamily: AppTheme.fonts.BUBBLE_BOBBLE,
    color: AppTheme.colors.white,
    textShadowColor: AppTheme.colors.outline,
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 2,
  },
  botttomView: {
    position: "absolute",
    bottom: 10,
  },
});
